import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default (reducers) => {
  const persistedReducer = persistReducer(
    {
      key: 'kulzer',
      storage,
      whitelist: ['autenticacao', 'usuario', 'parceiro'],
    },
    reducers
  );

  return persistedReducer;
};
